/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TUpdateVacancyModel,
  IUpdateVacancyRequest,
  IMappers,
  IUpdateVacancyResponse,
  IUpdateVacancyResponseError,
  TUpdateVacancyResponse,
} from './types';

const defaultConfig: TUpdateVacancyModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'vacancies',
  pathApi: '/v1/update-vacancy/',
  hostType: 'ud-api',
} as TUpdateVacancyModel;

function createUpdateVacancyModel(parameters: IUpdateVacancyRequest): TUpdateVacancyModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IUpdateVacancyOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IUpdateVacancyRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchUpdateVacancy<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IUpdateVacancyOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TUpdateVacancyResponse> {
  const { response, statusCode } = await httpApi.fetch(createUpdateVacancyModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IUpdateVacancyResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IUpdateVacancyResponseError);
    }
  }

  return { response, statusCode } as TUpdateVacancyResponse;
}

export { defaultConfig, createUpdateVacancyModel, fetchUpdateVacancy };
